export const LAYERDIV = 'LAYERDIV'